import {useCallback, useEffect, useState} from "react";
import {useHttp} from "./http.hook";
import {message} from "antd";
import {notifyNetworkError} from "../config/runtime";


export const useGetOnceHttp = ({url, method = 'GET', render = 0, body = null, def}, deps) => {
    const [data, setData] = useState(def);
    const {loading, request, error, clearError} = useHttp({def});

    const fetchData = useCallback(async () => {
        try {
            const newData = await request(url, method, body)
            setData( newData || def)
        } catch (e) {
            notifyNetworkError(message, `Ошибка сети: ${e.message}`)
        }
    }, [request, url])

    useEffect( () => {
        fetchData().then(() => ({}))}, [render, url]
    )

    return [data, loading, error]
}